// Global Functions
import { preventDoubleClick } from '../global/_doubleClick';
import { viewProductPersonalizationTracking } from '../global/_personalization';
import { formValidation } from '../global/_formValidation';
import { getUrlVar } from '../global/_getUrlVars';
import { getCookie, getCookieOrWebStorage } from '../global/_cookies';
import { adaCloseModalTarget } from '../global/_adaQuickViews';
// International Functions
import { removeIntlATB } from '../international/_removeIntlATB';
import { startIntl } from '../international/_intl';
// Product Display Functions
import { allDevicesColorSelectBox } from '../productDisplay/_shopperActions';
import { mobileTabletLongPress } from '../productDisplay/_longPress';
import { checkShipInternational } from '../productDisplay/_checkShipInternational';
import { zoomQVImageD, zoomQVImageMT } from '../productDisplay/_zoom';
import { iOSModalFix } from '../deviceSpecific/_iOS';
import { buildQV, freshenUp } from './_buildQV';
import { resetHorizontalRecs } from '../carousel/_pageSetup';
import { horzRecSlick } from '../productRecs/_horzRecSlick';
import { disableSlickArrow } from '../carousel/_disableSlickArrow';
import { replaceImage } from '../productDisplay/_images.js';
import { closeModalKeyboard } from '../modal/_closeModalKeyboard.js';

const addTrackingInfo = (trackingJSON) => {
	let availableForPurchase = $('.noLongerAvailable').length == 0 ? 'Y' : 'N';
	var categoryId = getUrlVar('categoryId') ? getUrlVar('categoryId') : '-10035',
		catentryId = $('#OrderItemAdd_qv').data('catentry');
	if (window.quickViewCategory) categoryId = window.quickViewCategory;
	if (!isNaN(categoryId)) var $specialPageType = $(`img[data-catentryid='${catentryId}']`).data('pagetype');
	var pageType = $specialPageType ? $specialPageType : 'PP-QV';
	adobeTracking.productPageDescriptionTracking(categoryId, pageType);
	if (pageType == 'PP-QV') {
		trackingJSON.product.isQuickView = 'Y';
		if ($('#selectedAdditionalSize').length > 0) {
			pageType = 'PP-QV-AS';
			trackingJSON.product.addSizeAttribute = $('#selectedAdditionalSize').text();
			$('#selectedAdditionalSize').remove();
		}
	}
	trackingJSON.product.availableForPurchase = availableForPurchase;
	try{
		dataLayer.page.primaryCategory = $('.personalizationsuperName').html();
		dataLayer.page.primaryCategoryId = $('.personalizationsuper').html();
	}catch(e){}
	trackingJSON.product.categoryId = categoryId;
	trackingJSON.product.singleProductResult = getUrlVar('singleProductResult');
	trackingJSON.product.pageType = pageType;
	adobeTracking.setProductInfo(trackingJSON);
	adobeTracking.buildProductListItems(trackingJSON);
};
const getSelectedAddtlsize = () => {
	if ($('.additionalSizeLink').length > 0) {
		$('.additionalSizeLink').on('click', function (e) {
			$('#selectedAdditionalSize').remove();
			$('body').append(`<div class="hidden" id="selectedAdditionalSize">${e.target.innerText}</div>`);
		});
	}
};

const taggingFunctions = () => {
	let uid = '',
		pId = $('.sku-quickview .qv-item-num').text(),
		type = document.body.className.indexOf('mobilePage') > -1 ? 'M' : document.body.className.indexOf('tabletPage') > -1 ? 'T' : 'D',
		CoreID6 = getCookie('CoreID6');
	window.criteo_q = window.criteo_q || [];
	window.criteo_q.push(
		{
			event: 'setAccount',
			account: 12055,
		},
		{
			event: 'setCustomerId',
			id: uid,
		},
		{
			event: 'setSiteType',
			type: type,
		},
		{
			event: 'viewItem',
			item: pId,
		}
	);
	checkShipInternational($('#shipInternationalQV').val(), true);
	if (CoreID6 != null && typeof CQuotient != 'undefined') {
		let clientId = 'dds',
			activityType = 'viewProduct',
			eId = $('#d_eId').text(),
			onSalePrice = '.quick-view-main-price .price-wrapper .now-price .price-number';
		var price = $(onSalePrice).length > 0 ? $(onSalePrice).text() : $('.quick-view-main-price .price-number').text();
		price = price.replace('$', '').replace(',', '');
		if (price != '') {
			eId != null && eId.length > 0
				? CQuotient.sendActivity(clientId, activityType, {
						cookieId: CoreID6,
						userId: eId,
						product: {
							id: pId,
							price: price,
						},
				  })
				: CQuotient.sendActivity(clientId, activityType, {
						cookieId: CoreID6,
						product: {
							id: pId,
							price: price,
						},
				  });
		}
	}
};

const altImgClick = () => {
	$('.modal .alt-image-list-container ul li img').on('click', function (e) {
		e.stopPropagation();
		var mainImage = $(this).parents('.modal-content').find('.mainImage')[0],
			newImage = $(this).data('fullimage'),
			selectedMainImage = $(this).data('fullimage').split('__')[0],
			mainImageSrc = $(mainImage).attr('src');
		if (mainImageSrc == '' || mainImageSrc.indexOf('/assets/img/') > -1 || mainImageSrc.indexOf('/shim.gif') > -1) {
			$(mainImage).attr('src', $(this).attr('src').split('/alt/').join('/main/'));
		} else {
			replaceImage($(mainImage), newImage);
		}
	});
};

const colorOptionHide = () => {
	$('.modal-quickview select.qvAttr').on('change', function () {
		if ($('option.defaultOption').prop('disabled') == false) {
			$('option.defaultOption').prop('disabled', true);
		}
	});
};

const cylSetup = () => {
	$('[data-qv=oss]').on('click', function (e) {
		let cylAccessoryImg = $(this).attr('src').split('DillardsZoom/')[1].split('?')[0],
			cylMainImg = $('.oss-modal .mainImage').attr('src').split('DillardsZoom/')[1].split('?')[0];
		if (cylAccessoryImg !== cylMainImg) {
			let modalTitle = $(this).data('title'),
				paramJSON = {
					catentryId: $(this).data('catentryid'),
					OSS: 'true',
				};
			$('.modal-backdrop').remove();
			$('.dynamicModalContainer').remove();
			buildQV(paramJSON, modalTitle);
			return false;
		}
	});
	// if ($('.desktopPage').length > 0) {
	//   $('.oss-modal .q-view-content').mCustomScrollbar({
	//     theme: "dark-3"
	//   });
	// }
};

const collectionSetup = () => {
	$('[data-qv=collection]').on('click', function (e) {
		let cylAccessoryImg = $(this).attr('src').split('DillardsZoom/')[1].split('?')[0],
			cylMainImg = $('.oss-modal .mainImage').attr('src').split('DillardsZoom/')[1].split('?')[0];
		if (cylAccessoryImg !== cylMainImg) {
			let modalTitle = $(this).data('title'),
				paramJSON = {
					catentryId: $(this).data('catentryid'),
					color: $(this).data('color'),
					collection: 'true',
					collectionArea: $(this).data('collectionarea'),
					color: $(this).data('color'),
				};
			$('.modal-backdrop').remove();
			$('.dynamicModalContainer').remove();
			buildQV(paramJSON, modalTitle);
			return false;
		}
	});
	// if ($('.desktopPage').length > 0) {
	//   $('.oss-modal .q-view-content').mCustomScrollbar({
	//     theme: "dark-3"
	//   });
	// }
};

const qvImgChange = (catentryId, isOSSOrCollection, color) => {
	var imgsForCatentryId = $(`img[data-catentryid="${catentryId}"]`);
	if (imgsForCatentryId.length > 1 && isOSSOrCollection && color) {
		imgsForCatentryId = $(`img[data-catentryid="${catentryId}"][data-color="${color}"]`);
	}
	if (imgsForCatentryId.length > 0 && imgsForCatentryId[0].src.indexOf('DillardsZoom/') > -1) {
		var selectedURL = imgsForCatentryId[0].src.split('/nav/').join('/main/').split('/productRec/').join('/main/');
		if (typeof selectedURL != 'undefined' && selectedURL.length > 0) $('.qv-modal .mainImage').attr('src', selectedURL);
		if (isOSSOrCollection) {
			//data-color is only used in OSS and collections, bug if clicking product rec while the same product is in OSS.
			var $currentColorCheck = imgsForCatentryId.data('color');
			if (typeof $currentColorCheck != 'undefined') {
				var $qvColorBox = $('.modal-quickview .color-select-group').find('option,.one-option');
				if ($qvColorBox.length > 0) {
					var showMessage = true;
					$($qvColorBox).each(function () {
						if ($(this).data('attrvalue').toLowerCase() == $currentColorCheck.toLowerCase()) {
							this.selected = true;
							$qvColorBox.trigger('change');
							showMessage = false;
							return;
						}
					});
					if (showMessage && !$('.oss-modal #errors').length > 0)
						$(`<div id="errors" class="alert alert-danger" role="alert">The color "${$currentColorCheck}" is not available.</div>`).insertBefore(
							'.modal-quickview .product-select-boxes'
						);
				}
			}
		}
	}
};

const addToRecentlyViewed_qv = (catEntryID, brandName) => {
	var title = $('.dynamicModalContainer strong').text(),
		productTitle = title.split('Description').join('').trim(),
		productTitleWithHyphens = productTitle.replace(/\s+/g, '-').split('"').join('').split('&').join('').split('?').join('').toLowerCase(),
		productURL = `/p/${productTitleWithHyphens}/${catEntryID}`,
		mainImage = $('.modal-quickview').find('.mainImage').prop('src');
	if ('undefined' != typeof mainImage) mainImage = mainImage.split('/main/').join('/productRec/');

	var newProductToAdd = [];
	newProductToAdd = [
		productTitle,
		productURL,
		mainImage.split('https:').join(''),
		'',
		'',
		'',
		'',
		'',
		'',
		catEntryID,
		'',
		'',
		brandName.split('&').join('and'),
	];
	var alreadyInRecentlyViewed = false,
		recentlyViewedProducts = [];
	try {
		recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewed') || []);
	} catch (e) {
		localStorage.removeItem('recentlyViewed');
	}
	
	var newRecentlyViewedProducts=recentlyViewedProducts.filter((rvProduct)=>{
		 
		const existingCatentryId= rvProduct[9]
		return existingCatentryId !== catEntryID;

	});
	if (recentlyViewedProducts.length >= 30) {
			recentlyViewedProducts.pop();
	}
	newRecentlyViewedProducts.unshift(newProductToAdd);
	localStorage.setItem('recentlyViewed', JSON.stringify(newRecentlyViewedProducts));

	let qvRecs;
	let fullProductTitle = '';
	let modalTitles = document.querySelectorAll(".dynamicModalContainer .modal-title>a");
	if (modalTitles) {
		for (let i = 0; i < modalTitles.length; i++) {
			fullProductTitle = fullProductTitle + modalTitles[i].textContent.trim() + ' ';
		}
		fullProductTitle.trim();
	}

	if (document.querySelectorAll(".desktopPage").length > 0) {
		qvRecs = `<li data-catentryid="${catEntryID}">
		<a id="qv-${catEntryID}" class="" data-modal-body='callQuickView({"catentryId":"${catEntryID}","categoryId": "SCPZ2_RV"})' data-target=".modal-quickview" data-toggle="modal" data-modal-title="${productTitle
			  .split('"')
			  .join('#double;')
			  .replace(/\s+/g, ' ')}" href="javascript:void(0)">
		<img alt="Image of ${fullProductTitle}" src="${mainImage}"></a><button class="rv-remove" type="button" tabindex='0' aria-label="remove" onclick="window.removeRecentlyViewedProduct('${catEntryID}')"><svg className="closeSVG" height="11" width="11" viewBox="0 0 16 16" role="img" aria-labelledby="removeRVItem-${catEntryID}"><title id="removeRVItem-${catEntryID}">Remove ${fullProductTitle} from recently viewed list</title><path d="M15.6,15.6c-0.5,0.5-1.4,0.5-1.9,0L8,9.9l-5.7,5.7c-0.5,0.5-1.4,0.5-1.9,0c-0.5-0.5-0.5-1.4,0-1.9L6.1,8L0.4,2.3c-0.5-0.5-0.5-1.4,0-1.9C0.7,0.1,1,0,1.3,0s0.7,0.1,1,0.4L8,6.1l5.7-5.7c0.5-0.5,1.4-0.5,1.9,0C15.9,0.7,16,1,16,1.3s-0.1,0.7-0.4,1L9.9,8l5.7,5.7C16.1,14.2,16.1,15.1,15.6,15.6z"/></svg></button><div class="rec-title"><p class="vert-rec-title">${productTitle}</p></div></a></li>`;
	} else {
		qvRecs = `<li data-catentryid="${catEntryID}">
  <a id="qv-${catEntryID}" class="" data-modal-body='callQuickView({"catentryId":"${catEntryID}","categoryId": "SCPZ2_RV"})' data-target=".modal-quickview" data-toggle="modal" data-modal-title="${productTitle
		.split('"')
		.join('#double;')
		.replace(/\s+/g, ' ')}" href="javascript:void(0)">
		<img alt="Image of ${fullProductTitle}" src="${mainImage}"></a><button class="rv-remove" type="button" tabindex='0' aria-label="remove" onclick="window.removeRecentlyViewedProduct('${catEntryID}')"><svg className="closeSVG" height="8" width="8" viewBox="0 0 16 16" role="img" aria-labelledby="removeRVItem-${catEntryID}"><title id="removeRVItem-${catEntryID}">Remove ${fullProductTitle} from recently viewed list</title><path d="M15.6,15.6c-0.5,0.5-1.4,0.5-1.9,0L8,9.9l-5.7,5.7c-0.5,0.5-1.4,0.5-1.9,0c-0.5-0.5-0.5-1.4,0-1.9L6.1,8L0.4,2.3c-0.5-0.5-0.5-1.4,0-1.9C0.7,0.1,1,0,1.3,0s0.7,0.1,1,0.4L8,6.1l5.7-5.7c0.5-0.5,1.4-0.5,1.9,0C15.9,0.7,16,1,16,1.3s-0.1,0.7-0.4,1L9.9,8l5.7,5.7C16.1,14.2,16.1,15.1,15.6,15.6z"/></svg></button><div class="rec-title"><p class="vert-rec-title">${productTitle}</p></div></a></li>`;

	} 
	if (
		!$(`.recently-viewed-results .rec-list [data-catentryid=${catEntryID}]`).length > 0 &&
		!$('#dynamicModalContainer div.alert.alert-danger.alert-dismissible').length > 0
	) {
		var horzRecText = $('.recently-viewed-results #horz-rec .rec-head').text();
		if (horzRecText.length == 0) $('.recently-viewed-results #horz-rec .rec-head').append('Recently Viewed Items');
		const renewSlick = (listElements, recList) => {
			if (recList.hasClass('slick-intialized')) recList.slick('unslick');
			horzRecSlick(listElements, recList);
		};
		if ($('.desktopPage').length > 0) {
			if ($('.recently-viewed-results .rec-list').hasClass('slick-initialized')) $('.recently-viewed-results .rec-list').slick('unslick');
		}
		$('.recently-viewed-results .rec-list').prepend(qvRecs);
		$('.recently-viewed-results #horz-rec').show();
		if ($('.recently-viewed-results #horz-rec').length > 0 && $('.desktopPage').length > 0)
			renewSlick($('.recently-viewed-results #horz-rec .rec-list li'), $('.recently-viewed-results #horz-rec .rec-list'));
		else if ($('#add-to-bag-rec').length > 0) renewSlick($('#add-to-bag-rec .rec-list li'), $('#add-to-bag-rec .rec-list'));
	}
	$('.recently-viewed-results #horz-rec .rec-list').css('top', '0');
	resetHorizontalRecs();
};

const qvClose_mt = (pos) => {
	if ($('html').hasClass('html-modal-open')) $('html').removeClass('html-modal-open');
	if ($('body').hasClass('modal-open')) $('body').removeClass('modal-open');
	if ($('body').hasClass('modal-special')) $('body').removeClass('modal-special');
	$('html, body').scrollTop(pos);
	$('body').css('top', '');
	adaCloseModalTarget();
};

const qvClose = (pos) => {
	$('html').removeClass('mobileScrollLock');
	$('.modal-backdrop').remove();
	$('.dynamicModalContainer').remove();
	adaCloseModalTarget();
	if (!$('.desktopPage').length > 0) qvClose_mt(pos);
};

const addtlSizeCloseQv = () => {
	if ($('.dynamicModalContainer').length > 1) {
		$('.dynamicModalContainer').first().remove();
	}
}

const qvClose_outside = (isOSSOrCollection, pos) => {
	let modal = isOSSOrCollection ? document.getElementById('quickviewOssModalDesktop') : document.getElementById('quickviewModalDesktop');
	let atbModal = 'dynamicModalContainer';
	window.onclick = function (event) {
		if (event.target == modal) {
			qvClose(pos);
			$('body').removeClass('modal-open');
			$('html').removeClass('html-modal-open');
		}
		if (event.target.id == atbModal && $('#layoutCart').length > 0 && $('.modal-add-to-bag').length > 0) {
			qvClose(pos);
			$('body').removeClass('modal-open');
			$('html').removeClass('html-modal-open');
		}
	};
	//adaCloseModalTarget();
};

const quickview = (qvHTML, paramJSON, trackingJSON, mainImgTString) => {
	$('body').append(qvHTML);
	let pos = $(document).scrollTop(),
		setTop = `-${pos}px`;
	taggingFunctions();
	addTrackingInfo(trackingJSON);
	try { $(document).trigger('PDP-QVCall'); } catch (e) {}
	preventDoubleClick();
	allDevicesColorSelectBox();
	addToRecentlyViewed_qv(paramJSON.catentryId, trackingJSON.product.brand);
	mobileTabletLongPress();
	altImgClick();
	colorOptionHide();
	startIntl();
	removeIntlATB();
	adobeTracking.setPageType('Product');
	closeModalKeyboard();
	if (paramJSON && paramJSON.categoryId && paramJSON.categoryId == 'syndeca' && window.syndecaTracking) {
		manualLinkClick(window.syndecaTracking);
	}

	if ($('.desktopPage').length > 0) {
		zoomQVImageD();
		qvClose_outside(paramJSON.OSS || paramJSON.collection, pos);
	} else if ($('.tabletPage').length > 0) {
		var modalheight = window.innerHeight;
		$('#quickviewModalDesktop').css('height', modalheight);
		$('body').addClass('modal-special');
		zoomQVImageMT(mainImgTString, qvImgChange, paramJSON.catentryId, paramJSON.color);
		qvClose_outside(paramJSON.OSS || paramJSON.collection, pos);
	} else {
		$('body').addClass('modal-open');
		$('body').css('top', setTop);
		$('html').addClass('mobileScrollLock');
		zoomQVImageMT(mainImgTString, qvImgChange, paramJSON.catentryId, paramJSON.color);
	}
	qvImgChange(paramJSON.catentryId, paramJSON.OSS || paramJSON.collection, paramJSON.color);
	$('[data-dismiss="modal"]').on('click', function () {
		qvClose(pos);
		$('body').removeClass('modal-open');
		$('html').removeClass('html-modal-open');
		adaCloseModalTarget();
	});
	cylSetup();
	collectionSetup();
	if(!($('#registryLayout').length > 0)){
		viewProductPersonalizationTracking();
	}
	formValidation();
	iOSModalFix();
	addtlSizeCloseQv();
	getSelectedAddtlsize();

	//---------------------------
	(function () {
		if ($('#layoutCart').length > 0) {
			$('#add-to-bag').on('click', function () {
				checkForErrors(this);
			});
			$('#add-to-wishlist').on('click', function () {
				checkForErrors(this);
			});
			$('#add-to-registry').on('click', function () {
				checkForErrors(this);
			});
		}

		if ($('#layoutMember').length > 0) {
			$('#add-to-bag').on('click', function () {
				checkForErrors(this);
			});
			$('#add-to-registry').on('click', function () {
				checkForErrors(this);
			});
		}

		window.closeTip = function () {
			$('.invalidComboContainer').remove();
		};

		$('ul.flat li').on('click', function () {
			$(this).closest('div[class*="select-group-flat-qv"]').removeClass('has-error');
		});

		window.checkForErrors = function () {
			const invalidSelects = document.querySelectorAll('.form-attr.invalidSelection');
			const formGroups = document.querySelectorAll('.form-group.form-attr');
			const erroredAttrs = document.querySelectorAll('.form-group.has-error');
			let html = '';
			if (invalidSelects.length > 0 && invalidSelects.length === formGroups.length) {
				html = "<div id='invalidComboContainer' class='invalidComboContainer' tabIndex='0'><div class='closeTip' onClick='closeTip()' tabIndex='0'>&#215;</div><p><span>!</span>Your combination isn't available at this time. Choose from the available options to continue..</p></div>";
			} else {
				if (erroredAttrs.length > 0) {
					let errorStr = '';
					erroredAttrs.forEach((attr, index) => {
						let attrName = attr.querySelector('label').innerHTML.toLowerCase();
						if (erroredAttrs.length > 2 && index > 0) {
							errorStr += ', ';
						}
						if (erroredAttrs.length > 1 && index === erroredAttrs.length -1) {
							errorStr += ' and ';
						}
						errorStr += attrName;
					});
				
					const article = errorStr && ['a', 'e', 'i', 'o', 'u'].indexOf(errorStr.toLowerCase()[0]) > -1 ? ' an ' : ' a ';
					html = '<div id="invalidComboContainer" class="invalidComboContainer" tabIndex="0"><div class="closeTip" onClick="closeTip()" tabIndex="0">&#215;</div><p><span>!</span>Select' + article + errorStr + ' to continue.</p></div>';
				}
			}
			
			if ($('.modal-body .has-error').length > 0) {
				$(html).insertBefore('#add-to-bag');
				$('ul.flat.qvAttr, .product-select-boxes select').attr('aria-describedby', 'invalidComboContainer');
			}
			
			if ($('.size-select-group-flat-qv span.popover-error').length > 0) {
				$('ul.flat.qvAttr').focus();
			}
			$('.invalidComboContainer').focus();
		};
	})();

	$('.product-select-boxes select').on('change', function () {
		if ($('.has-error').length == 0) {
			closeTip();
		}
	});

	$('.modal-body').on('click touchstart', function () {
		closeTip();
	});
	
	try { $(document).trigger('triggerPageView'); } catch (e) {}
	
	try{
		if(typeof window.ddsAdobeIsReady === 'function'){
			$(document).trigger('triggerPageViewEvent');
		}else{

			var maxAttempts = 200;
			var totalAttempts = 0;
		
			function isAdobeInitiated() {
				if (totalAttempts < maxAttempts) {
					totalAttempts++;
					if (typeof window.ddsAdobeIsReady === 'function') {
						$(document).trigger('triggerPageViewEvent');
						clearInterval(pageViewInterval);
					}
				} else {
					clearInterval(pageViewInterval);
				}
			}
			var pageViewInterval = setInterval(isAdobeInitiated, 50);
		}
	}catch(e){
		console.log(e);
	}

	//-------------------------------------
};

export { quickview, qvClose_mt, qvImgChange };
